<h1 mat-dialog-title>
  {{data?.nome}}&nbsp;&nbsp;
  <button type="button" class="close m-3" aria-label="Fechar">
    <span aria-hidden="true" (click)="dialogRef.close()">&times;</span>
  </button>
</h1>

<div mat-dialog-content>
  <mat-horizontal-stepper [linear]="true" #negociacaoStepper>
    <mat-step *ngIf="!usuarioEstaLogado">
      <app-registro-cliente *ngIf="!usuarioJaTemUmaConta" subtitulo="{{'antes_iniciar_conhecer' | transloco}}"
        (registroFinalizado)="registroFinalizado($event)">
      </app-registro-cliente>

      <app-acesso-cliente *ngIf="usuarioJaTemUmaConta" subtitulo="{{'antes_iniciar_acesso' | transloco}}"
        (acessoFinalizado)="acessoFinalizado($event)">
      </app-acesso-cliente>
    </mat-step>
    <mat-step [stepControl]="negociacaoFormGroup">
      <form [formGroup]="negociacaoFormGroup">
        <h3>{{'personalize_negociacao' | transloco}}</h3>
        <div mat-icon-button class="m-3" (click)="toggleRegionalization()">
          <span class="h5">{{'localizacao_negociacao' | transloco}}</span>
          <mat-icon class="icon-expand">{{showRegionalization ? 'expand_less': 'expand_more'}}</mat-icon>
        </div>
        <mat-card-content *ngIf="showRegionalization">
          <p class="section-description col-12">
            {{'escolha_locais' | transloco}}
          </p>
          <div class="selected-locations col-12" *ngIf="selectedLocations.length > 0">
            <mat-chip-listbox>
              <mat-chip *ngFor="let location of selectedLocations" [removable]="selectedLocations.length > 1" [ngClass]="{
                  'country-selected': location.type === 'country',
                  'state-selected': location.type === 'state',
                  'single-selection': selectedLocations.length === 1
                }" (removed)="removeLocation(location)">
                <mat-icon matChipAvatar>{{ getLocationIcon(location) }}</mat-icon>
                {{ getLocationDescription(location) }}
                <mat-icon *ngIf="selectedLocations.length > 1" matChipRemove matTooltipPosition="above"
                  matTooltip="Remover">
                  cancel
                </mat-icon>
                <mat-icon *ngIf="selectedLocations.length === 1" matChipRemove matTooltipPosition="above"
                  matTooltip="{{'remover_localizacao' | transloco}}">
                  cancel
                </mat-icon>
              </mat-chip>
            </mat-chip-listbox>
          </div>
          <div class="search-controls col-12">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>{{'buscar_localizacao' | transloco}}</mat-label>
              <input type="text" matInput [(ngModel)]="searchTerm" (input)="onSearch($event)"
                (focus)="showDropdown = true" [placeholder]="city || ('digite_cidade' | transloco)"
                (keyup.enter)="searchLocations($event)">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
          <mat-card class="dropdown" *ngIf="showDropdown" (clickOutside)="closeDropdown()">
            <!-- Header da Sugestão -->
            <div class="suggestion-header" *ngIf="nearestCity">
              <mat-icon class="suggestion-icon">location_on</mat-icon>
              <span>A localização <strong>{{nearestCity}}</strong> é sugerida.</span>
              <button type="button" mat-icon-button class="close-suggestion" (click)="closeDropdown()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <!-- Lista de Localizações -->
            <mat-nav-list class="location-list">
              <mat-list-item *ngFor="let location of filteredLocations" (click)="toggleLocation(location)"
                [class.selected]="location.selected">
                <mat-icon matListItemIcon>{{ getLocationIcon(location) }}</mat-icon>

                <div [class.text-inversu]="location.selected" matListItemTitle *ngIf="location.type !== 'city'">{{
                  location.name }}</div>
                <div [class.text-inversu]="location.selected" matListItemLine *ngIf="location.type === 'city'">
                  {{ getLocationDescription(location) }}
                </div>

                <div matListItemMeta class="item-meta">
                  <mat-chip class="location-type-chip">
                    {{ location.type === 'state' ? ('estado_endereco' | transloco) : location.type === 'country' ? ('pais_endereco' | transloco) : ('cidade_endereco' | transloco) }}
                  </mat-chip>
                  <mat-checkbox [checked]="location.selected" (change)="toggleLocation(location)"
                    (click)="$event.stopPropagation()"></mat-checkbox>
                </div>
              </mat-list-item>
            </mat-nav-list>
          </mat-card>
        </mat-card-content>
        <div class="row mb-3">
        </div>
        <div class="row">
          <div class="col-xl-6">
            <app-lista [opcoes]="duracoes" [formulario]="negociacaoFormGroup" nomeControle="duracao"
              descricao="{{'duracao_negociacao' | transloco}}" classe="horizontal-100"></app-lista>
          </div>

          <div class="col-xl-6">
            <app-campo [formulario]="negociacaoFormGroup" nomeControle="quantidade"
              descricao="{{'quantidade_simples' | transloco}}" classe="horizontal-100"></app-campo>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6">
            <app-campo-dinheiro [formulario]="negociacaoFormGroup" nomeControle="valor_pretendido"
              descricao="{{'valor_pretendido_unidade' | transloco}}"
              textoAjuda="{{'valor_pretendido_unidade' | transloco}}" classe="horizontal-100"></app-campo-dinheiro>
          </div>
          <div class="col-xl-6">
            <mat-checkbox class="pt-3" formControlName="encerrar_automaticamente">{{'finalizar_lance_igual' |
              transloco}}</mat-checkbox>
          </div>

          <div class="col-xl-12">
            <h5 class="text-muted">{{'condicao_produto' | transloco}}</h5>

            <mat-radio-group aria-label="Select an option" formControlName="condicao">
              <mat-radio-button value="novo">{{'novo' | transloco}}</mat-radio-button>
              <mat-radio-button value="usado">{{'usado' | transloco}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-xl-6">
            <app-botao texto="{{'iniciar_negociacao' | transloco}}" [executando]="loading"
              classe="btn-primary horizontal-100" posicaoDoIcone="direita" (clique)="iniciaNegociacao()">
            </app-botao>
          </div>
          <div class="col-xl-6 order-xl-first">
            <app-botao texto="{{'cancelar' | transloco}}" [desabilitado]="loading"
              classe="btn-link text-uppercase order-sm-last horizontal-100" (clique)="dialogRef.close()">
            </app-botao>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step>

      <h3><strong class="text-inversu">{{'tudo_certo' | transloco}}</strong></h3>
      <p>{{'aguardar_ofertas' | transloco}}</p>

      <div class="row pt-4">
        <div class="col-xl-6">
          <app-botao texto="{{'ver_negociacao' | transloco}}" [executando]="loading" classe="btn-primary horizontal-100"
            posicaoDoIcone="direita" icone="fa-solid fa-arrow-up-right-from-square" (clique)="irParaNegociacao()">
          </app-botao>
        </div>
        <div class="col-xl-6 order-xl-first">
          <app-botao texto="{{'ok_entendi' | transloco}} =)" [desabilitado]="loading"
            classe="btn-link text-uppercase horizontal-100" (clique)="dialogRef.close()">
          </app-botao>
        </div>
      </div>
    </mat-step>

  </mat-horizontal-stepper>
</div>